"use client";

import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Visionary() {
  const [currentTime, setCurrentTime] = useState("06:00");
  useEffect(() => {
    const times = ["06:00", "09:00", "12:00", "15:00", "18:00", "21:00"];
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % times.length;
      setCurrentTime(times[index]);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section data-section-id="2838" id="the-visionary-launchpad" className="relative h-screen rounded-2xl w-full overflow-hidden text-foreground">
      <iframe src="https://www.youtube.com/embed/VmJar-a9Buw?autoplay=1&mute=1&loop=1&playlist=VmJar-a9Buw&controls=0&showinfo=0&rel=0" className="absolute top-1/2 left-1/2 w-[100vw] h-[56.25vw] min-h-[100vh] min-w-[177.77vh] -translate-x-1/2 -translate-y-1/2 pointer-events-none" allow="autoplay; encrypted-media" title="Background Video" />
      
      <div className="absolute inset-0 bg-black/40 z-10 pointer-events-none" />

      <div className="pointer-events-none absolute inset-x-0 inset-y-0 z-10 border-t-[12px] border-b-[12px] md:border-t-[16px] md:border-b-[16px]" style={{
      borderColor: "hsl(47 91% 53%)"
    }} aria-hidden="true">
        <div className="h-full w-full border-[1px]" style={{
        borderColor: "#7C3AED"
      }} />
      </div>

      <div className="absolute left-8 top-8 z-20 md:left-12 md:top-12">
        <span className="font-default text-xs tracking-[0.2em] uppercase" style={{
        color: "hsl(0 0% 60%)"
      }}>
          {currentTime} <span className="mx-1 opacity-50">→</span> 21:00
        </span>
      </div>

      <div className="absolute right-8 top-8 z-20 md:right-12 md:top-12">
        <span className="font-default text-xs tracking-[0.3em] uppercase" style={{
        color: "hsl(47 91% 53%)"
      }}>
          MARINELA
        </span>
      </div>

      <div className="relative z-20 flex h-full flex-col justify-center items-start px-8 pb-24 pt-32 md:px-16 md:pb-16 lg:px-24">
        <div className="max-w-4xl text-left">
          <h1 className="font-default font-bold leading-[1.0] tracking-tighter text-foreground" style={{
          fontSize: "clamp(3.5rem, 8vw, 6rem)"
        }}>Cosa vuol dire per&nbsp; te comunicare?</h1>

          <p className="mt-8 max-w-xl font-default text-xl" style={{
          color: "hsl(0 0% 60%)"
        }}>This is a Storytelling digital project</p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="h-14 bg-primary px-8 font-default text-xs font-bold uppercase tracking-[0.2em] text-primary-foreground hover:bg-primary/90 rounded-lg w-full sm:w-auto">
              <Link to="/LioniaProjectPage">Cosa è - Lionia Project? →</Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="h-14 px-8 font-default text-xs font-bold uppercase tracking-[0.2em] text-foreground border border-border hover:bg-accent hover:text-accent-foreground rounded-lg w-full sm:w-auto">
              <Link to="/LioniaProjectPage">Voglio partecipare</Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-12 right-8 z-20 hidden md:flex md:right-12 lg:right-16">
        <div className="flex flex-col items-center gap-4">
          <span className="font-default text-xs tracking-[0.3em] uppercase [writing-mode:vertical-rl] rotate-180" style={{
          color: "hsl(0 0% 60%)"
        }}>
            Scroll — Explore
          </span>
          <div className="relative h-20 w-px overflow-hidden" style={{
          backgroundColor: "hsl(0 0% 16%)"
        }}>
            <div className="absolute top-0 left-0 w-full animate-scroll-line" style={{
            height: "40%",
            background: "linear-gradient(to bottom, transparent, hsl(47 91% 53%), transparent)"
          }} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll-line {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(250%); }
        }
        .animate-scroll-line {
          animation: scroll-line 2s ease-in-out infinite;
        }
      `}</style>
    </section>;
}